import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";

const columns = [
  "ID",
  "Activity Date",
  "Brand ID",
  "User Unique ID",
  "Regs",
  "FTD",
  "QFTD",
  "Net Revenue",
];

const BrandOverviewTableSkeleton = ({ rows = 6 }: { rows?: number }) => {
  return (
    <Table>
      {/* Table Header */}
      <TableHead>
        <TableRow>
          {columns.map((_, index) => (
            <TableCell key={index}>
              <Skeleton variant="text" width={80} height={20} />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      {/* Table Body */}
      <TableBody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {columns.map((_, colIndex) => (
              <TableCell key={colIndex}>
                <Skeleton
                  variant="text"
                  width={colIndex === 0 ? 180 : 100}
                  height={20}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default BrandOverviewTableSkeleton;
